import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Typography,
  Box,
  Card,
  CardContent,
  CircularProgress,
  useMediaQuery,
  useTheme,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MoreIcon from '@mui/icons-material/More';
const typeColor = (type) => {
  switch (type) {
    case "supervisor": return "warning";
    case "employee": return "primary";
    default: return "default";
  }
};

const EmployeeTable = ({
  employeeList,
  loader,
  page,
  rowsPerPage,
  total,
  setPage,
  setRowsPerPage,
  handleEdit,
  handleDelete,
  handleOpenCamera,
  handleOpenMoreDetails,
  
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const data = employeeList || [];

  if (loader) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", height: 300, alignItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, width: "100%" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        Employee List
      </Typography>

      {/* Desktop View */}
      {!isMobile ? (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1976d2" }}>
                {["S.No", "Code", "Name", "Designation","Department", "Mobile", "Type", "Status", "Actions"].map((h) => (
                  <TableCell key={h} sx={{ color: "white", fontWeight: "bold" }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data.length > 0 ? (
                data.map((emp, index) => (
                  <TableRow key={emp.id} hover>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{emp.employee_code || "-"}</TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>

                        <img
                          src={
                            emp.image_url
                              ? emp.image_url
                              : "https://ui-avatars.com/api/?name=User&background=random"
                          }
                          alt="profile"
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                          }}
                        />

                        <Typography variant="body2">
                          {emp.contact_name || `${emp.fname} ${emp.lname || ""}`.trim()}
                        </Typography>

                      </Box>
                    </TableCell>
                    {/* <TableCell>{emp.contact_name || `${emp.fname} ${emp.lname || ""}`.trim()}</TableCell> */}
                    <TableCell>{emp.designation_name|| "-"}</TableCell>
                    <TableCell>{emp.department_name || "-"}</TableCell>
                    <TableCell>{emp.mobile || "-"}</TableCell>
                    <TableCell>
                      <Chip
                        label={(emp.type || "staff").toUpperCase()}
                        color={typeColor(emp.type)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ color: emp.status ? "green" : "red", fontWeight: "bold" }}>
                        {emp.status ? "ACTIVE" : "INACTIVE"}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={0.5}>
                        <IconButton
                          size="small"
                          onClick={() => handleEdit(emp)}
                          sx={{ backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } }}
                          title="Edit"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(emp.id)}
                          sx={{ backgroundColor: "error.main", color: "white", "&:hover": { backgroundColor: "error.dark" } }}
                          title="Deactivate"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleOpenCamera(emp)}
                          sx={{ backgroundColor: "error.main", color: "white", "&:hover": { backgroundColor: "error.dark" } }}
                          title="Deactivate"
                        >
                          <AddAPhotoIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleOpenMoreDetails(emp.id)}
                          sx={{ backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } }}
                        >
                          <MoreIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">No Data Found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        /* Mobile View */
        <Box>
          {data.length > 0 ? (
            data.map((emp, index) => (
              <Card key={emp.id} sx={{ mb: 2, borderLeft: "5px solid #1976d2", boxShadow: 2 }}>
                <CardContent>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: "bold", color: "#1976d2" }}>
                      #{page * rowsPerPage + index + 1}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: emp.status ? "green" : "red", fontWeight: "bold" }}
                    >
                      {emp.status ? "ACTIVE" : "INACTIVE"}
                    </Typography>
                  </Box>


                  <Box display="flex" alignItems="center" gap={1}>

                    <img
                      src={
                        emp.image_url
                          ? emp.image_url
                          : "https://ui-avatars.com/api/?name=User&background=random"
                      }
                      alt="profile"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                      }}
                    />

                    <Typography variant="body2">
                      {emp.contact_name || `${emp.fname} ${emp.lname || ""}`.trim()}
                    </Typography>

                  </Box>

                  {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    {emp.contact_name || `${emp.fname} ${emp.lname || ""}`.trim()}
                  </Typography> */}

                  {emp.employee_code && (
                    <Typography variant="body2" color="text.secondary">
                      Code: {emp.employee_code}
                    </Typography>
                  )}
                  {emp.designation_name && (
                    <Typography variant="body2">Designation: {emp.designation_name}</Typography>
                  )}
                  {emp.department_name && (
                    <Typography variant="body2">Department: {emp.department_name}</Typography>
                  )}
                  <Typography variant="body2">Mobile: {emp.mobile || "-"}</Typography>

                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={(emp.type || "staff").toUpperCase()}
                      color={typeColor(emp.type)}
                      size="small"
                    />
                  </Box>

                  <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(emp)}
                      sx={{ backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(emp.id)}
                      sx={{ backgroundColor: "error.main", color: "white", "&:hover": { backgroundColor: "error.dark" } }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenCamera(emp)}
                      sx={{ backgroundColor: "error.main", color: "white", "&:hover": { backgroundColor: "error.dark" } }}
                    >
                      <AddAPhotoIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenMoreDetails(emp.id)}
                      sx={{ backgroundColor: "primary.main", color: "white", "&:hover": { backgroundColor: "primary.dark" } }}
                    >
                      <MoreIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography align="center">No Data Found</Typography>
          )}
        </Box>
      )}

      {/* Pagination */}
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        sx={{ mt: 2 }}
      />
    </Box>
  );
};

export default EmployeeTable;
